module.exports = {
  getHeight(element) {
    let totalHeight = 0;
    Array.prototype.forEach.call(element.children, (el) => {
      if (!el.classList.contains('visually-hidden')) {
        const style = getComputedStyle(el);
        totalHeight += parseInt(el.offsetHeight, 10);
        totalHeight += parseInt(style.marginTop, 10);
        totalHeight += parseInt(style.marginBottom, 10);
      }
    });
    return totalHeight;
  },
};
